<template>
  <div class="results-counter" :style="{ marginBottom: bottomMargin }">
    <span class="results-text">
      Показано
      <strong>{{ shownFrom }} - {{ shownTo }}</strong>
      из
      <strong>{{ totalCount }}</strong>
      записей
    </span>
  </div>
</template>

<script>
export default {
  name: "ResultsCounter",
  props: {
    bottomMargin: {
      type: String,
      default: null,
    },
    paginationMeta: {
      type: Object,
      required: true,
    },
  },

  computed: {
    shownFrom() {
      if (this.paginationMeta.from) return this.paginationMeta.from;
      const { page, limit } = this.paginationMeta;

      return (page - 1) * limit + 1;
    },

    shownTo() {
      if (this.paginationMeta.to) return this.paginationMeta.to;
      const { page, limit, count } = this.paginationMeta;

      return Math.min(page * limit, count);
    },

    totalCount() {
      return this.paginationMeta.count;
    },
  },
};
</script>

<style scoped>
.results-counter {
  margin-bottom: var(--base-out-indent);
}

.results-text {
  font-size: 14px;
  color: #666;
}

.results-text strong {
  color: #333;
}

.page-info {
  font-size: 14px;
  color: #999;
  margin-left: 8px;
}
</style>
